import { createAction } from '@reduxjs/toolkit';
import { Job } from './model';

export const jobsInserted = createAction<{ jobs: Job[] }, 'al/uploader/jobsInserted'>(
  'al/uploader/jobsInserted',
);

export const jobUpdated = createAction<
  { jobID: string; jobProps: Partial<Job> },
  'al/uploader/jobUpdated'
>('al/uploader/jobUpdated');

export const jobRestarted = createAction<{ jobID: string }, 'al/uploader/jobRestarted'>(
  'al/uploader/jobRestarted',
);

export const cancelAllJobs = createAction<void, 'al/uploader/cancelAllJobs'>(
  'al/uploader/cancelAllJobs',
);

export const modalOpened = createAction<
  { pendingUpload?: boolean } | undefined,
  'al/uploader/modalOpened'
>('al/uploader/modalOpened');

export const modalClosed = createAction<void, 'al/uploader/modalClosed'>('al/uploader/modalClosed');

export const pendingUploadCleared = createAction<void, 'al/uploader/pendingUploadCleared'>(
  'al/uploader/pendingUploadCleared',
);
